export const environment = {
	production: false,
	baseUrl: 'https://api-qat.vehicle.ford.com/svl/',
	environment: 'QA',
	oauth: {
		url: 'https://corpqa.sts.ford.com/adfs/oauth2/authorize',
		client_id: 'urn:fleetportal:clientid:web_fleetportal:qa',
		resource_id: 'urn:fleetportal:resource:web_fleetportal:qa',
		response_type: 'token',

		strAccessToken: 'KAPLAPCEJP',
		encodedAccessToken: 'WTHILTIG',
		tokenIssue: 'YFTTSLHERU',
		tokenExp: 'YRIRAT',
		userId: 'PIEIEKNPI',
		block_redirect: 'NAIBHRDOAWS',
		permissions: 'ECILEAST',
		logged_history: 'UALN'
	}
};